import useCustomLayoutMode, { LayoutMode } from '@/hooks/useCustomLayoutMode';
import { CustomDialogTitle, CustomDragableDialog, flatSx } from '@local/ui';
import { Button, DialogActions, DialogContent, MenuItem, Select, Stack } from '@mui/material';
import clsx from 'clsx';
import { rootSx } from './style';

export type ChangeLayoutDialogProps = {
  className?: string;
  open: boolean;
  onClose: () => void;
};

export default function ChangeLayoutDialog(props: ChangeLayoutDialogProps) {
  const { open, onClose, className } = props;
  const [layoutMode, setLayoutMode] = useCustomLayoutMode();
  return (
    <CustomDragableDialog
      backLightOn
      className={clsx('ChangeLayoutDialog-root', className)}
      sx={flatSx(rootSx)}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <CustomDialogTitle title="메뉴 설정 변경" onClose={onClose}></CustomDialogTitle>
      <DialogContent dividers>
        <Select value={layoutMode} onChange={(e) => setLayoutMode(e.target.value as LayoutMode)}>
          <MenuItem value={'sidebar'}>Sidebar</MenuItem>
          <MenuItem value={'topbar'}>Topbar</MenuItem>
        </Select>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button onClick={onClose}>닫기</Button>
        </Stack>
      </DialogActions>
    </CustomDragableDialog>
  );
}
